module.exports = __webpack_public_path__ + "img/china.f21af281.svg";